import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Button from "../components/Button";
import Dialog from "../components/Dialog";

const UnsavedChangesDialogControls = styled.div`
  display: flex;
  gap: 2rem;
`;

const UnsavedCopy = styled.div`
  padding: 0;
  font-family: ${(props) => props.theme.fonts.baseSemiBold};
  font-size: 2.4rem;
  text-transform: uppercase;
  line-height: 1;
`;

const UnsavedChangesDialogCopy = styled.div`
  margin-bottom: ${(props) => props.theme.space[6]};
  font-size: ${(props) => props.theme.fontSizes[2]};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black};
`;

export interface IUnsavedChangesDialog {
  handleConfirm: () => void;
  handleHide: () => void;
}

const UnsavedChangesDialog: React.FC<IUnsavedChangesDialog> = ({
  handleConfirm,
  handleHide,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog closeDialog={handleHide}>
      <Dialog.Header closeDialog={handleHide}>
        <UnsavedCopy>
          {t("unsavedChangesModal.heading", "You have unsaved changes")}
        </UnsavedCopy>
      </Dialog.Header>
      <Dialog.Body isPadded={true}>
        <UnsavedChangesDialogCopy>
          {t(
            "unsavedChangesModal.body",
            "Are you sure you want to leave this page?",
          )}
        </UnsavedChangesDialogCopy>
        <UnsavedChangesDialogControls>
          <Button variant="primary" onClick={handleHide} width={1}>
            {t("unsavedChangesModal.negative", "No")}
          </Button>
          <Button variant="primary" onClick={handleConfirm} width={1}>
            {t("unsavedChangesModal.affirmative", "Yes")}
          </Button>
        </UnsavedChangesDialogControls>
      </Dialog.Body>
    </Dialog>
  );
};

export default UnsavedChangesDialog;
